export default __webpack_public_path__ + "static/media/tilman_ruff.0c9ba91e.jpg";